// TODO: figure out where to put this helper. Decouple from challenges. Web common? File management module?
export const getFileFromImageUrl = async (
  imageUrl: string,
  newFileName: string,
) => {
  const res = await fetch(imageUrl);
  const imageBlob = await res.blob();
  return new File([imageBlob], newFileName);
};
